import FastAPIInstance from '../../services/risksystem3-public-api';
import {
  GetShareClassParams,
  ShareClassModel,
} from './types';

// API Functions for React Query

/**
 * Get share class information
 * @param params - Query parameters including client_id, fund_id (optional), share_class_id (optional), and only_active_share_class
 * @returns Promise<ShareClassModel[]>
 */
export const getShareClass = async (
  params: GetShareClassParams,
): Promise<ShareClassModel[]> => {
  const {
    client_id,
    fund_id,
    share_class_id,
    only_active_share_class = true,
  } = params;

  const queryParams = new URLSearchParams({
    client_id,
    only_active_share_class: only_active_share_class.toString(),
  });

  if (fund_id) {
    queryParams.append('fund_id', fund_id);
  }

  if (share_class_id) {
    queryParams.append('share_class_id', share_class_id);
  }

  return (
    await FastAPIInstance.get<ShareClassModel[]>(
      `/v1/share_class?${queryParams.toString()}`,
    )
  ).data;
};
